// 消息总线
import Vue from "vue";
export default new Vue();



// WEBPACK FOOTER //
// ./src/utils/Bus.js